["resize", "load"].forEach(event => {
  window.addEventListener(event, function() {
    if (window.innerWidth <= 768) {
      document.querySelectorAll('.custom-collection-list__content').forEach(ccl => {
        let flkty = new Flickity( ccl, {
          // options
          cellAlign: 'left',
          contain: true,
          prevNextButtons: false,
          pageDots: false
        });
      });
    } else {
      document.querySelectorAll('.custom-collection-list__content').forEach(ccl => {
        let flkty = new Flickity( ccl, {
          // options
          cellAlign: 'left',
          contain: true,
          prevNextButtons: false,
          pageDots: false
        });
        flkty.destroy(true);
      });
    }
  });
});


document.addEventListener('DOMContentLoaded', function() {
  // document.querySelectorAll('.header-info-box .heading').forEach(heading => {
  //   heading.addEventListener('click', e => {
  //     const headingElement = e.target.closest('.heading');
  //     if (headingElement.nextElementSibling != null) {
  //       console.log(headingElement.nextElementSibling.clientHeight);
  //       console.log(headingElement.nextElementSibling.scrollHeight);
  //       if (headingElement.nextElementSibling.clientHeight == 10) {
  //         headingElement.nextElementSibling.style.height = headingElement.nextElementSibling.scrollHeight + 'px';
  //         headingElement.nextElementSibling.style.visibility = 'visible';
  //       } else {
  //         headingElement.nextElementSibling.style.height = '0px';
  //         headingElement.nextElementSibling.style.visibility = 'hidden';
  //       }
  //     }
  //   });
  // });
let sizeCheck = function() {
  const sizeField = document.querySelector('fieldset.product-form__input[data-handle="available-sizes"]');
  
  if (!sizeField) return false; // Exit the function if element doesn't exist
  
  sizeField.classList.remove('highlight-custom');
  
  if (document.querySelector(`.variations .product-form__input--block input[type=radio][name="Available Sizes"].is-disabled:checked`) != null) {
    document.querySelector('.custom-single-add-to-cart-button').classList.remove('hide');
    document.querySelector('.custom-single-add-to-cart-button').nextElementSibling.classList.add('hide');
    return true;
  } else {
    document.querySelector('.custom-single-add-to-cart-button').classList.add('hide');
    document.querySelector('.custom-single-add-to-cart-button').nextElementSibling.classList.remove('hide');
    return false;
  }
}
// Where sizeCheck is called
if (document.querySelector('.custom-single-add-to-cart-button') != null) {
  document.querySelector('.custom-single-add-to-cart-button').addEventListener('click', e => {
    const sizeChecked = sizeCheck();
    if (sizeChecked) {
      const sizeField = document.querySelector('fieldset.product-form__input[data-handle="available-sizes"]');
      if (sizeField) {
        sizeField.classList.add('highlight-custom');
      }
    }
  });
}

  document.querySelectorAll('.custom-mega-menu-wrapper').forEach(function(megaMenu) {
    const handle = megaMenu.dataset.handle;
    if (window.innerWidth >= 1068) {
      const parentItem = document.querySelector(`.menu-item-top[data-handle="${handle}"]`);
    
      if (parentItem != null) {
        // console.log('megaMenu', megaMenu);
        parentItem.appendChild(megaMenu);
        parentItem.querySelectorAll('.hide').forEach(hiddenEle => {
          hiddenEle.classList.remove('hide');
        });
      } 
    } else {
      const parentItem = document.querySelector(`.mobile-menu li[data-handle="${handle}"]`);

      if (parentItem != null) {
        parentItem.appendChild(megaMenu);
        
        parentItem.querySelectorAll('.hide').forEach(hiddenEle => {
          hiddenEle.classList.remove('hide');
        });
        parentItem.querySelector('.link-forward').classList.remove('hide');
      }
    }
  });

  document.addEventListener('click', e => {
    if (e.target.closest('.custom-mega-menu__top-link-item') != null) {
      return false;
    }
    if ((e.target.tagName == 'A' && e.target.closest('.mobile-menu') != null) ) {
      if (e.target.nextElementSibling != null) {
        e.preventDefault();
        e.target.nextElementSibling.classList.toggle('open');      
        e.target.nextElementSibling.offsetHeight == 0 ? e.target.nextElementSibling.style.height = e.target.nextElementSibling.scrollHeight + 'px' : e.target.nextElementSibling.style.height = '0px'; 
      }
    } else if (e.target.closest('a') != null && e.target.closest('.mobile-menu') != null) {
      if (e.target.closest('a').nextElementSibling != null) {
        e.preventDefault(); 
        e.stopPropagation();
        e.target.closest('a').nextElementSibling.classList.toggle('open');
        e.target.closest('a').nextElementSibling.offsetHeight == 0 ? e.target.closest('a').nextElementSibling.style.height = e.target.closest('a').nextElementSibling.scrollHeight + 'px' : e.target.closest('a').nextElementSibling.style.height = '0px';
      }
    }
  });



  let showSpecification = function() {
    let selectedVariantTitle = '';
    document.querySelectorAll('input:checked').forEach(function(singleVariant) {
      selectedVariantTitle += singleVariant.value + ' / ';
    });
    selectedVariantTitle = selectedVariantTitle.substring(0, selectedVariantTitle.length - 3);

    console.log('selectedVariantTitle', selectedVariantTitle);
    
    document.querySelectorAll('.product-specification div[data-variant]').forEach(ele => {
      ele.classList.add('hide');
    });
    if (document.querySelector(`.product-specification div[data-variant="${selectedVariantTitle}"]`) != null) {
      document.querySelector(`.product-specification div[data-variant="${selectedVariantTitle}"]`).classList.remove('hide'); 
    }
    console.log(document.querySelector(`.product-specification div[data-variant="${selectedVariantTitle}"]`));
  }
let showProductFAQ = function() {
    // Get the selected product type
    const selectedRadio = document.querySelector(`.variations .product-form__input--block input[type=radio]:checked`);
    const selectedProductType = selectedRadio != null ? selectedRadio.value : '';
    
    // First, hide all FAQs
    document.querySelectorAll('.product-type-faq__left collapsible-row').forEach(ele => {
      ele.classList.add('hide');
    });
    
    // Show FAQs that match the selected product type
    document.querySelectorAll('.product-type-faq__left collapsible-row').forEach(ele => {
      // Check for "all types" first
      if (ele.getAttribute('data-all-types') === 'true') {
        ele.classList.remove('hide');
        return;
      }
      
      // Get the product type attribute and split by commas
      const faqTypeValue = ele.getAttribute('data-product-type') || '';
      const faqTypes = faqTypeValue.split(',').map(type => type.trim());
      
      // Check if any of the specified types match the current product type
      for (let i = 0; i < faqTypes.length; i++) {
        if (faqTypes[i] === selectedProductType) {
          ele.classList.remove('hide');
          break;
        }
      }
    });
}

  document.querySelectorAll('.product-form__input input').forEach(ele => {
    ele.addEventListener('change', function(e) {
      setTimeout(function() {
        showSpecification();
        showProductFAQ();
        sizeCheck();
      }, 500);
    });
  });


function repositionMegaMenuButton() {
  if (window.innerWidth <= 767) { // Mobile breakpoint
    document.querySelectorAll('.custom-mega-menu-wrapper.style3').forEach(function(menuWrapper) {
      const bottomButton = menuWrapper.querySelector('.custom-mega-menu__bottom-button');
      const menuHeading = menuWrapper.querySelector('.custom-mega-menu__heading');
      
      if (bottomButton && menuHeading) {
        // Move the button before the heading (not after)
        menuHeading.parentNode.insertBefore(bottomButton, menuHeading);
      }
    });
  } else {
    // Restore original position on desktop
    document.querySelectorAll('.custom-mega-menu-wrapper.style3').forEach(function(menuWrapper) {
      const bottomButton = menuWrapper.querySelector('.custom-mega-menu__bottom-button');
      
      if (bottomButton) {
        // Move the button to the end of the wrapper
        menuWrapper.appendChild(bottomButton);
      }
    });
  }
}

  // Run on page load
  repositionMegaMenuButton();

// Run on window resize
window.addEventListener('resize', repositionMegaMenuButton);

// Check if product form exists before calling related functions
if (document.querySelector('.product-form__input')) {
  showSpecification();
  showProductFAQ();
  sizeCheck();
}

});